import { defaultTypeDescription } from 'src/constants/dataSourceTypeDescription';
import { Connection } from 'src/store/connections/types';
import { ReduxState } from 'src/store/types';

export const dataSourceTypeDescriptionSelector =
  (connection: Connection | null) => (state: ReduxState) =>
    (connection &&
      state.dataSources.typeDescriptionByConnectionId[connection.id]) ||
    defaultTypeDescription;
